import Vue from 'vue';
import Router from 'vue-router';
import Index from '@/pages/Index.vue';
import Login from '@/pages/Login.vue';
import Receiving from '@/pages/Receiving.vue';
import ReceivingDetail from '@/pages/ReceivingDetail.vue';
import GoodsShelves from '@/pages/GoodsShelves.vue';
import Picking from '@/pages/Picking.vue';
import PickingDetail from '@/pages/PickingDetail.vue';
import PickingGoodsDetail from '@/pages/PickingGoodsDetail.vue';
import CheckStock from '@/pages/CheckStock.vue';
import CheckStockDetail from '@/pages/CheckStockDetail.vue';
import Print from '@/pages/Print.vue';
import Search from '@/pages/Search.vue';
import SearchGoodsDetail from '@/pages/SearchGoodsDetail.vue';
import Allocate from '@/pages/Allocate.vue';
import AllocateDetail from '@/pages/AllocateDetail.vue';
import AllocateGoodsList from '@/pages/AllocateGoodsList.vue';
import StockMove from '@/pages/StockMove.vue';
import StockMoveDetail from "@/pages/StockMoveDetail.vue";
import UnShelvesList from "@/pages/UnShelvesList.vue";
import OrderCancel from '@/pages/OrderCancel.vue';
import OrderCancelDetail from "@/pages/OrderCancelDetail.vue";

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      component: Login
    },
    {
      path: '/index',
      component: Index
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/receiving',
      component: Receiving
    },
    {
      path: '/receivingDetail',
      component: ReceivingDetail
    },
    {
      path: '/goodsShelves',
      component: GoodsShelves
    },
    {
      path: '/picking',
      component: Picking
    },
    {
      path: '/pickingDetail',
      component: PickingDetail
    },
    {
      path: '/pickingGoodsDetail',
      component: PickingGoodsDetail
    },
    {
      path: '/checkStock',
      component: CheckStock
    },
    {
      path: '/checkStockDetail',
      component: CheckStockDetail
    },
    {
      path: '/print',
      component: Print
    },
    {
      path: '/search',
      component: Search
    },
    {
      path: '/searchGoodsDetail',
      component: SearchGoodsDetail
    },
    {
      path: '/allocate',
      component: Allocate
    },
    {
      path: '/allocateDetail',
      component: AllocateDetail
    },
    {
      path: '/allocateGoodsList',
      component: AllocateGoodsList
    },
    {
      path: '/stockMove',
      component: StockMove
    },
    {
      path: '/stockMoveDetail',
      component: StockMoveDetail
    },
    {
      path: '/unShelvesList',
      component: UnShelvesList
    },
    {
      path: '/orderCancel',
      component: OrderCancel
    },
    {
      path: '/orderCancelDetail',
      component: OrderCancelDetail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js